module.exports = __webpack_public_path__ + "static/img/04.ac758340.jpg";